export default function normalizeString(string: string) {
  return string
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  //https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
}
